import { useFormikContext } from 'formik'
import React from 'react'
import type { LoyaltyRules } from '../../../../../types/loyalty'
import { EditableRuleCard } from './EditableRuleCard'
import { RuleNumberInput } from './RuleNumberInput'
import { RuleRow } from './RuleRow'

const Icon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M12 2L2 7l10 5 10-5-10-5z" />
    <path d="M2 17l10 5 10-5" />
    <path d="M2 12l10 5 10-5" />
  </svg>
)

export const EarnRulesCard: React.FC = () => {
  const { values, errors, setFieldValue } = useFormikContext<LoyaltyRules>()

  const earnErrors = (errors.earn ?? {}) as Record<string, unknown>
  const silverErr = (
    (earnErrors.silver as Record<string, string> | undefined) ?? {}
  ).rate
  const goldErr = (
    (earnErrors.gold as Record<string, string> | undefined) ?? {}
  ).rate
  const platinumErr = (
    (earnErrors.platinum as Record<string, string> | undefined) ?? {}
  ).rate

  return (
    <EditableRuleCard
      title="Earn Rules"
      description="How members earn points on every purchase, with optional tier-based multipliers"
      icon={<Icon />}
      cardPath="earn"
      enablePath="earn.enable"
    >
      <RuleRow
        name="Base earn rate"
        description="Points earned per dollar spent"
        control={
          <RuleNumberInput
            value={values.earn.base_rate}
            onChange={(next) => setFieldValue('earn.base_rate', next)}
            unit="pts / $1"
            min={0}
            step={0.5}
            error={
              typeof earnErrors.base_rate === 'string'
                ? earnErrors.base_rate
                : undefined
            }
          />
        }
      />
      <RuleRow
        name="Silver multiplier"
        description="Bonus rate for Silver tier (500–1,999 lifetime pts)"
        control={
          <RuleNumberInput
            value={values.earn.silver.rate}
            onChange={(next) => setFieldValue('earn.silver.rate', next)}
            unit="× rate"
            min={1}
            step={0.25}
            error={silverErr}
          />
        }
      />
      <RuleRow
        name="Gold multiplier"
        description="Bonus rate for Gold tier (2,000–4,999 lifetime pts)"
        control={
          <RuleNumberInput
            value={values.earn.gold.rate}
            onChange={(next) => setFieldValue('earn.gold.rate', next)}
            unit="× rate"
            min={1}
            step={0.25}
            error={goldErr}
          />
        }
      />
      <RuleRow
        name="Platinum multiplier"
        description="Bonus rate for Platinum tier (5,000+ lifetime pts)"
        control={
          <RuleNumberInput
            value={values.earn.platinum.rate}
            onChange={(next) => setFieldValue('earn.platinum.rate', next)}
            unit="× rate"
            min={1}
            step={0.25}
            error={platinumErr}
          />
        }
        isLast
      />
    </EditableRuleCard>
  )
}
